module.exports = __webpack_public_path__ + "images/header-logo-2x.01ef898811a879595cea.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/header-logo-2x.png
// module id = uYjZ
// module chunks = 24